import React from "react";

const OptionPost = (props: {[key: string]: any}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="more_horizontal_24__Page-2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="more_horizontal_24__more_horizontal_24">
        <path id="more_horizontal_24__Bounds" d="M24 0H0v24h24z"></path>
        <path
          d="M18 10a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2c0-1.1.9-2 2-2Zm-6 4a2 2 0 0 1-2-2c0-1.1.9-2 2-2a2 2 0 0 1 2 2 2 2 0 0 1-2 2Zm-6 0a2 2 0 0 1-2-2c0-1.1.9-2 2-2a2 2 0 0 1 2 2 2 2 0 0 1-2 2Z"
          id="more_horizontal_24__Mask"
          fill="currentColor"
        ></path>
      </g>
    </g>
  </svg>
);

export default OptionPost;
